import { ITeam } from '@/data/models/Team'
import { IPlayer } from '@/data/models/Player'
import { IProtocol } from '@/data/models/Protocol'
import i18n from '@/plugins/i18n'

export enum EventType {
  TRAINING = 'training',
  MATCH = 'match',
  READINESS = 'readiness',
  TEST_SESSION = 'test_session',
  MEETING = 'meeting',
  ANALYSIS = 'analysis',
  VIDEO_ANALYSIS = 'video_analysis',
  MEDICAL_EXAM = 'medical_exam',
  THERAPY = 'therapy',
  REHAB = 'rehab',
  INDIVIDUAL_WORK = 'individual_work',
  MEAL = 'meal',
  REST = 'rest',
  TEAM_BUILDING = 'team_building',
  TRAVEL = 'travel',
  OTHER = 'other'
}

export enum TravelMeans {
  BUS = 'bus',
  AIRPLANE = 'airplane',
  CAR= 'car',
  TRAIN = 'train'
}

export const EventTypes = {
  [EventType.TRAINING]: {
    color: 'orange',
    get text() {
      return i18n.t('performance.advanced.training')
    },
    is_other: false
  },
  [EventType.MATCH]: {
    color: 'red',
    get text() {
      return i18n.t('performance.advanced.match')
    },
    is_other: false
  },
  [EventType.READINESS]: {
    color: 'blue-grey lighten-2',
    get text() {
      return i18n.t('event_type.readiness')
    },
    is_other: true
  },
  [EventType.TEST_SESSION]: {
    color: 'blue',
    get text() {
      return i18n.t('event_type.test_session')
    },
    is_other: true
  },
  [EventType.MEETING]: {
    color: 'blue-grey lighten-2',
    get text() {
      return i18n.t('event_type.meeting')
    },
    is_other: true
  },
  [EventType.ANALYSIS]: {
    color: 'blue-grey lighten-2',
    get text() {
      return i18n.t('event_type.analysis')
    },
    is_other: true
  },
  [EventType.VIDEO_ANALYSIS]: {
    color: 'blue-grey lighten-2',
    get text() {
      return i18n.t('event_type.video_analysis')
    },
    is_other: true
  },
  [EventType.MEDICAL_EXAM]: {
    color: 'blue-grey lighten-2',
    get text() {
      return i18n.t('event_type.medical_exam')
    },
    is_other: true
  },
  [EventType.THERAPY]: {
    color: 'blue-grey lighten-2',
    get text() {
      return i18n.t('event_type.therapy')
    },
    is_other: true
  },
  [EventType.REHAB]: {
    color: 'blue-grey lighten-2',
    get text() {
      return i18n.t('event_type.rehab')
    },
    is_other: true
  },
  [EventType.INDIVIDUAL_WORK]: {
    color: 'blue-grey lighten-2',
    get text() {
      return i18n.t('event_type.individual_work')
    },
    is_other: true
  },
  [EventType.MEAL]: {
    color: 'blue-grey lighten-2',
    get text() {
      return i18n.t('event_type.meal')
    },
    is_other: true
  },
  [EventType.REST]: {
    color: 'blue-grey lighten-2',
    get text() {
      return i18n.t('event_type.rest')
    },
    is_other: true
  },
  [EventType.TEAM_BUILDING]: {
    color: 'blue-grey lighten-2',
    get text() {
      return i18n.t('event_type.team_building')
    },
    is_other: true
  },
  [EventType.TRAVEL]: {
    color: 'blue-grey lighten-2',
    get text() {
      return i18n.t('event_type.travel')
    },
    is_other: true
  },
  [EventType.OTHER]: {
    color: 'blue-grey lighten-2',
    get text() {
      return i18n.t('event_type.other')
    },
    is_other: true
  }
}

export const TravelMeansList = {
  [TravelMeans.BUS]: {
    get text() {
      return i18n.t('event_means_of_travel.bus')
    }
  },
  [TravelMeans.AIRPLANE]: {
    get text() {
      return i18n.t('event_means_of_travel.airplane')
    }
  },
  [TravelMeans.CAR]: {
    get text() {
      return i18n.t('event_means_of_travel.car')
    }
  },
  [TravelMeans.TRAIN]: {
    get text() {
      return i18n.t('event_means_of_travel.train')
    }
  }
}

export interface IEvent {
  id: number;
  start_at: string;
  end_at: string;
  players: IPlayer[];
  event_type: string;
  teams: ITeam[];
  protocol_id: number;
  protocol?: IProtocol;
}
